// src/components/ClientRegForm.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { addFormData, checkClientUsernameExists } from '../firebase';

export default function RegistrationForm({ closeModal = () => {} }) {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    bio: '',
    username: '',
    password: ''
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { username } = form;

    const exists = await checkClientUsernameExists(username);
    if (exists) {
      alert('Username already taken! Please choose another.');
      return;
    }

    try {
      // write into Clients collection
      await addFormData(form, 'Clients', username);

      setForm({ name: '', email: '', phone: '', bio: '', username: '', password: '' });

      // go to the client portal
      navigate(`/portal/${username}`);

    } catch (err) {
      console.error('Error creating client portal:', err);
      alert('Oops! Something went wrong. Please try again.');
    }
  };

  return (
    <form className="portfolio-reg-form" onSubmit={handleSubmit}>

      <input
        type="text"
        name="name"
        placeholder="Full Name"
        value={form.name}
        onChange={handleChange}
        required
      />

      <input
        type="email"
        name="email"
        placeholder="Email Address"
        value={form.email}
        onChange={handleChange}
        required
      />

      <input
        type="text"
        name="phone"
        placeholder="Contact Number"
        value={form.phone}
        onChange={handleChange}
      />

      <textarea
        name="bio"
        className="input-field about-field"
        placeholder="Brand Represented"
        value={form.bio}
        onChange={handleChange}
        rows="4"
        required
      />

      <input
        type="text"
        name="username"
        placeholder="Your Position"
        value={form.username}
        onChange={handleChange}
        required
      />

      <input
        type="password"
        name="password"
        placeholder="Access Code"
        value={form.password}
        onChange={handleChange}
        required
      />

      <button type="submit" className="button primary is-fullwidth">
      Get Started
      </button>
    </form>
  );
}

